import { createApi } from '@reduxjs/toolkit/query/react';
import { type AdditionalContentReferralMilestone } from '@strata/react-timeline';

import { CLIENT_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const clientApi = createApi({
    baseQuery: getBaseQuery(CLIENT_API_URL),
    refetchOnMountOrArgChange: true,
    reducerPath: 'clientApi',
    endpoints: (build) => ({
        getReferralMilestones: build.query<
            AdditionalContentReferralMilestone[],
            { payerId: string; referralId: string }
        >({
            query: ({ payerId, referralId }) => ({
                url: `referrals/${payerId}/referrals/${referralId}/milestones`,
                headers: { 'x-npi': payerId },
            }),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred retrieving referral milestones.',
            ),
        }),
    }),
});

export const { useGetReferralMilestonesQuery } = clientApi;
